/* eslint import/prefer-default-export: 0 */
import countBy from 'lodash/countBy';
import sampleSize from 'lodash/sampleSize';
import times from 'lodash/times';

import randomLineUpPoolSelector from '../selectors/randomLineUpPoolSelector';
import positionsSelector from '../selectors/positionsSelector';

// TODO - this gets called every time OpenChallenge updates. Make a selector maybe?
export function randomLineUpGenerator(state) {
  // const t0 = performance.now();
  const playersAndTeams = randomLineUpPoolSelector(state);

  const allPositions = positionsSelector(state);
  const positions = allPositions.filter(p => !p.shareQuota || !p.isTeam);
  const quota = state.challenge.playerQuota + state.challenge.teamQuota;

  const lockedOnly = positions.map(pos => pos.selections.filter(x => x.locked));

  const minPositionsToFill = positions.reduce(
    (memo, pos, index) => [
      ...memo,
      ...times(Math.max(pos.min, lockedOnly[index].length), () => pos.id)
    ],
    []
  );
  const extraPositionsToFill = positions.reduce(
    (memo, pos, index) => [
      ...memo,
      ...times(pos.max - Math.max(pos.min, lockedOnly[index].length), () => pos.id)
    ],
    []
  );
  const func = () => {
    const totalPositionsToFill = [
      ...minPositionsToFill,
      ...sampleSize(extraPositionsToFill, quota - minPositionsToFill.length)
    ];
    const positionAllocationMap = countBy(totalPositionsToFill);
    return positions.map((pos, index) => {
      const lockedEntities = lockedOnly[index];
      const quantity = positionAllocationMap[pos.id];

      if (lockedEntities.length >= quantity) {
        return pos;
      }
      const randomSelections = sampleSize(
        playersAndTeams[pos.id],
        quantity - lockedEntities.length
      );
      return {
        ...pos,
        selections: [...lockedEntities, ...randomSelections]
      };
    });
  };

  // const t1 = performance.now();
  // console.log(`Call to doSomething took ${t1 - t0} milliseconds.`);
  return func;
}
